import React, { useEffect, useState } from "react";

/**
 * Sticky horizontal reading-progress bar at the top of the viewport.
 * Tracks scroll inside the targeted `<article>` element (or document body).
 */
export default function BlogReadingProgress({ targetRef }) {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const el = targetRef?.current;
      if (el) {
        const rect = el.getBoundingClientRect();
        const total = el.offsetHeight - window.innerHeight;
        const scrolled = Math.max(0, -rect.top);
        const p = total > 0 ? Math.min(100, (scrolled / total) * 100) : 0;
        setPct(p);
      } else {
        const total = document.documentElement.scrollHeight - window.innerHeight;
        const p = total > 0 ? Math.min(100, (window.scrollY / total) * 100) : 0;
        setPct(p);
      }
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [targetRef]);

  return (
    <div
      className="fixed top-0 left-0 right-0 z-50 h-1 bg-transparent pointer-events-none"
      aria-hidden="true"
      data-testid="blog-reading-progress"
    >
      <div
        className="h-full bg-gradient-to-r from-blue-500 via-violet-500 to-fuchsia-500 transition-[width] duration-150 ease-out"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
